<template>
    <div
        v-if="templates.have"
        class="templates display--flex position--relative"
    >
        <div class="templates__label capitalize">{{ `${ $t('global.templates') }: ` }}</div>
        <div
            v-for="( template, index ) in templates.list"
            :key="`template-${index}`"
            class="templates__template pointer"
            :class="{ 'disable': loading }"
            aria-role="button"
            @click="exportsFiles( template.endpoint )"
            @click.middle="exportsFiles( template.endpoint )"
        >
            {{ template.format }}
        </div>
        <a class="download" download></a>
        <loading-dot
            v-if="loading"
        />
        <template v-if="errorExport">
            <span class="templates__error">{{ $t('error.download') }}</span>
        </template>
    </div>
</template>

<script>

// Mixins
import exportFiles from '@/helpers/exportFiles';

export default {
    mixins: [ exportFiles ],
    components: {
        LoadingDot: () => import( /* webpackChunkName: 'LoadingDot' */ '@/components/bundles/loadings/Dot' )
    },
    props: {
        templates: {
            type: Object,
            default: () => ({ have: false })
        }
    }
};
</script>

<style lang="scss">
    .templates {
        @include typography-specs( 14px, 18px );
        margin-top: 20px;
        flex-wrap: wrap;
        &__error {
            width: 100%;
            color: $color-red
        }
        &__template {
            margin-left: 5px;
            text-decoration: underline;
            &:hover {
                color: $color-green;
            }
        }
    }
</style>